import script from "./DocxViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocxViewer.vue?vue&type=script&setup=true&lang=js"

import "./DocxViewer.vue?vue&type=style&index=0&id=736930f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736930f4"]])

export default __exports__